import { UserPlus, Repeat, Globe } from "lucide-react";

interface ApplicationType {
    id: string;
    label: string;
    icon: typeof UserPlus;
}

interface ApplicationTypeSelectionProps {
    selectedType: string | null;
    onSelect: (type: string) => void;
    showTransfer: boolean;
    showExchange: boolean;
}

export default function ApplicationTypeSelection({
    selectedType,
    onSelect,
    showTransfer,
    showExchange,
}: ApplicationTypeSelectionProps) {
    // Build available application types
    const applicationTypes: ApplicationType[] = [
        { id: 'First Year Student', label: 'First Year Student', icon: UserPlus },
        ...(showTransfer ? [{ id: 'Transfer Student', label: 'Transfer Student', icon: Repeat }] : []),
        ...(showExchange ? [{ id: 'Exchange', label: 'Exchange', icon: Globe }] : []),
    ];

    const cardCount = applicationTypes.length;
    const gridClasses = cardCount === 2 
        ? "grid sm:grid-cols-2 gap-4 max-w-xl mx-auto"
        : "grid sm:grid-cols-2 lg:grid-cols-3 gap-4";

    return (
        <div className="space-y-6">
            <div className="text-center space-y-2">
                <h3 className="text-xl font-bold text-slate-900">Select Application Type</h3>
                <p className="text-sm text-muted-foreground">
                    Choose the type of application that best describes your situation
                </p>
            </div>
            <div className={gridClasses}>
                {applicationTypes.map((appType) => {
                    const Icon = appType.icon;
                    const isSelected = selectedType === appType.id;
                    return (
                        <button
                            key={appType.id}
                            onClick={() => onSelect(appType.id)}
                            className={`group p-6 rounded-xl border-2 bg-white transition-all text-left ${
                                isSelected 
                                    ? 'border-emerald-500 shadow-md bg-emerald-50/30' 
                                    : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50/50'
                            }`}
                        >
                            <div 
                                className="w-12 h-12 rounded-full flex items-center justify-center mb-4 transition-colors"
                                style={{ 
                                    backgroundColor: '#001b4415',
                                    color: '#001b44'
                                }}
                            >
                                <Icon size={24} />
                            </div>
                            <h4 className="font-bold text-slate-900">{appType.label}</h4>
                            {isSelected && (
                                <div className="mt-3 text-xs font-semibold text-emerald-600">
                                    ✓ Selected
                                </div>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
